import { React, useState, useContext, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Paper, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import postData from './postData';
import { LoadingButton } from '@mui/lab';
import { AuthContext } from './AuthContext';
import { useParams, useHistory } from 'react-router-dom';
import Loadingalert from './LoadingAlert';
import thumbsUpImage from './images/thumbs-up.gif';
import ImageModal from './imageModal';

import Tiptap from './TipTap.tsx';


const IssueCommentForm = () => {

  //form variables
  const { baseURL } = useContext(AuthContext);
  const editorRef = useRef(null) //reference to tiptap editor
  const history = useHistory();

  const { sk } = useParams();  //get parameter from router
  const [isInitialized, setIsInitialized] = useState(false);
  const [submitting, setSubmitting] = useState(false);


  //issue values
  const [fullName, setFullName] = useState("");
  const [neighborhoodName, setNeighborhoodName] = useState("");
  const [isCitywide, setIsCityWide] = useState(false);
  const [isOnlyComment, setIsOnlyComment] = useState("");
  const [neighborhoodSupport, setNeighborhoodSupport] = useState(null);
  const [body, setBody] = useState("");
  const [rsIssue, setrsIssue] = useState(undefined);
  const [imageFilename, setImageFileName] = useState(null);

  // comment values
  const [fullNameComment, setFullNameComment] = useState("");
  const [emailComment, setEmailComment] = useState("");
  const [residency, setResidency] = useState(null);
  const [opinion, setOpinion] = useState(null);
  const [approveLabel, setApproveLabel] = useState("");
  const [disaproveLabel , setDisapproveLabel] = useState("");

  //warning dialog variables
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  //---------------------------------------------------
  // initialize the issue values

  const retrieveIssueInfo = async () => {
    const formData = new FormData();
    formData.append('issueSK', sk);
    formData.append('isActive', 1);
    formData.append('neighborhoodSK', null);
    var objData = await postData(baseURL + 'issueSelect.php', formData);
    if (objData.theError === "") {
      setrsIssue(objData.theData);
    } else {
      setErrorMessage(objData.theError);
    }
  }
  
  useEffect(() => {
    if (isInitialized === false) {
      if (sk === '0') {
        setFullName('');
        setIsCityWide(0);
        setBody('');
        setImageFileName('');
        setIsInitialized(true);
      } else {
        retrieveIssueInfo();
      }
    }
// eslint-disable-next-line     
  },[isInitialized,sk])

  useEffect(() => {
    if (rsIssue !== undefined) {
      setFullName(rsIssue[0].fullName);
      setNeighborhoodName(rsIssue[0].neighborhoodName);
      setIsCityWide(rsIssue[0].isCityWide);
      setBody(rsIssue[0].body);
      setIsOnlyComment(rsIssue[0].isOnlyComment)
      if (rsIssue[0].isOnlyComment === "1") {
          setOpinion("1")
      }
      if (rsIssue[0].imageFileName !== null) {
        setImageFileName(baseURL + "upload/" + rsIssue[0].imageFileName);
      }
      if (rsIssue[0].approveDescription !== "") {
      setApproveLabel(" (" + rsIssue[0].approveDescription + ")");
      }
      if (rsIssue[0].disapproveDescription !== "") {
        setDisapproveLabel(" (" + rsIssue[0].disapproveDescription + ")");
      }
      if (rsIssue[0].neighborhoodSupport === null){
        setNeighborhoodSupport(null);
      } else {
        setNeighborhoodSupport(rsIssue[0].neighborhoodSupport.slice(0,rsIssue[0].neighborhoodSupport.length - 2));
      }

      setIsInitialized(true);
    }
  }, [rsIssue, baseURL])


  //---------------------------------------------------

  const saveComment = async () => {
    let isComplete = true;

    // get content from tiptap editor
    
    let bodyComment = "";
    if (editorRef.current) {
      bodyComment = editorRef.current.getHTML();
      console.log('Editor HTML:', bodyComment);
    }

    // perform additional validity checkings
    if (residency === null) {
      isComplete = false;
      setErrorMessage("Please choose your residency status.");
    }

    // when only retrieving comments
    if (isOnlyComment === "1") {
      setOpinion("1")
      if (bodyComment === "") {
        isComplete = false;
        setErrorMessage("Please enter a comment.");
      }
    }

    if (opinion === null) {
      isComplete = false;
      setErrorMessage("Please select one of the opinion options.");
    }

    // Regular expression to validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(emailComment);
    if (isValidEmail === false) {
      isComplete = false;
      setErrorMessage("The email address does not appear to be valid.");
    }

    if (isComplete) {
      setSubmitting(true);
 
      //save to database
      const formData = new FormData();
      formData.append('issueSK', sk);
      formData.append('fullName', fullNameComment);
      formData.append('email', emailComment);
      formData.append('residency', residency);
      formData.append('opinion', opinion);
      formData.append('body', bodyComment);
      let objData = await postData(baseURL + 'issueCommentAddEdit.php', formData);
      if (objData.theError === "") {
        //congratulate user
        setOpenSuccessDialog(true);
      } else {
        setErrorMessage(objData.theError);
        setSubmitting(true);
      }
    }  //isComplete
  };


  //---------------------------------------------------
  // ----- handle user warning
  useEffect(() => {
    if (errorMessage !== '') {
      setOpenWarningDialog(true);
    }
  }, [errorMessage]
  )
  const handleDialogOK = () => {
    setOpenWarningDialog(false);
    setErrorMessage('');
  };

  const handleSuccessDialogOK = () => {
       //go back to home screen
       history.push(`/`);
  };
  //---------------------------------------------------
  return (<>
    {(isInitialized === false) && <Loadingalert />}
    <div>
      <h3  id="header" dangerouslySetInnerHTML={{ __html: fullName }} />
      <figure>
        {/*
 {(imageFilename !== null) && <img src={imageFilename} alt="....Nothing..." style={{ maxWidth: '40%', border: '2px solid #2b9ed4' }} />}

  */}
        {(imageFilename !== null) && <ImageModal imageUrl={imageFilename} />}
               <figcaption style={{ fontStyle: "italic",marginBottom:'10px' }} >{(neighborhoodName !== null) && <>Created by {neighborhoodName}</>}
          {(isCitywide === '1') && <> (affects many neighborhoods)</>}
          {(neighborhoodSupport !== null) && <> & supported by {neighborhoodSupport}</>}
        </figcaption>
      </figure>
      <div id="body" style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: body }} />
      <Paper elevation={10}>
        <h3 style={{ paddingTop: '15px' }}>What do you think?</h3>
        <Formik
          initialValues={{
            fullName: '',
            email: '',
          }}
          onSubmit={async (values) => {
            saveComment();
          }}
        >
          <Form style={{ textAlign: "left", padding: 10 }}>

            <label htmlFor="fullName"  style={{ marginTop: -10 }}>Name</label>
            <Field
              name="fullName"
              type="text"
              value={fullNameComment}
              onChange={(e) => setFullNameComment(e.target.value)}
              style={{ width: "50%" }}
              required
            />

            <label htmlFor="email">Email</label>
            <Field
              name="email"
              type="text"
              value={emailComment}
              onChange={(e) => setEmailComment(e.target.value)}
              style={{ width: "50%" }}
              required
            />

            <label htmlFor="residency" sx={{ padding: '0', border: '1pt solid' }}>Residency</label>
            <RadioGroup
              name="residency"
              value={residency}
              onChange={(event) => setResidency(event.target.value)}
              row
              sx={{ paddingTop: '5px', paddingBottom: '5px' }}
              required
            >
              {(neighborhoodName !== null) && (neighborhoodName !== '') && <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="2" value="2" control={<Radio sx={{ padding: '1px' }} />} label={neighborhoodName + " resident"} />}
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="1" value="1" control={<Radio sx={{ padding: '1px' }} />} label="City resident" />
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="3" value="3" control={<Radio sx={{ padding: '1px' }} />} label="County resident" /> 
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="4" value="4" control={<Radio sx={{ padding: '1px' }} />} label="Work in county" />                
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="0" value="0" control={<Radio sx={{ padding: '1px' }} />} label="Vistor" />
            </RadioGroup>
            
            {isOnlyComment !== "1"  &&
            <label htmlFor="opinion" sx={{ padding: '0', border: '1pt solid' }}>Opinion</label> }

            {isOnlyComment !== "1"  &&
            <>
            <RadioGroup
              name="opinion"
              value={opinion}
              onChange={(event) => setOpinion(event.target.value)}
              row
              sx={{ paddingTop: '5px', paddingBottom: '15px' }}
              required
            > 
            
         
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="1" value="1" control={<Radio sx={{ padding: '1px' }} />} 
                                  label={       
                                     <>
                                    <Typography variant="body" component="span">
                                      Approve
                                    </Typography>
                                    <Typography variant="caption" component="span">
                                      {approveLabel}
                                    </Typography>
                                  </>} />
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="0" value="0" control={<Radio sx={{ padding: '1px' }} />} label="Neutral" />
              <FormControlLabel sx={{ padding: '1px', marginTop: '0' }} key="-1" value="-1" control={<Radio sx={{ padding: '1px' }} />} 
                                  label={       
                                     <>
                                    <Typography variant="body" component="span">
                                      Oppose
                                    </Typography>
                                    <Typography variant="caption" component="span">
                                      {disaproveLabel}
                                    </Typography>
                                  </>} />
            </RadioGroup>
            </>}
            <div style={{ paddingTop: '10px' }}>
               <Tiptap ref={editorRef}  />
              </div>
            <div className='formButtonContainer'>
              <LoadingButton type="submit" loading={submitting} disabled={submitting} variant='contained'>Submit</LoadingButton>
            </div>            
            <p style={{fontSize:'0.8em', marginTop:35 ,fontStyle: 'italic'}}>
              Your sentiment will be combined with others into a consolidated weekly email that gets sent to local government officials and community leaders (which includes running tallies of the public’s opinion). One weekly email allows the recipient to focus rather than being distracted by separate emails thoughout the day.
            </p>
          </Form>
        </Formik></Paper>
    </div>
    <Dialog
      open={openWarningDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Alert
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {errorMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogOK}>Ok</Button>
      </DialogActions>
    </Dialog>
    <Dialog
      open={openSuccessDialog}
      aria-labelledby="success-dialog-title"
      aria-describedby="success-dialog-description"
    >
      <DialogTitle id="success-dialog-title">
        Congratulations
      </DialogTitle>
      <DialogContent><div style={{textAlign:"center"}}>
        <img src={thumbsUpImage} 
             alt="..thumbs up.." 
             style={{ maxWidth: '20%', height: 'auto' }}
        /></div>
        <DialogContentText id="success-dialog-description">
          Your thoughts have been saved and your voice will be heard.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSuccessDialogOK}>Continue</Button>
      </DialogActions>
    </Dialog>
  </>

  );
};

export default IssueCommentForm;